import React from 'react';
import { Box, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Typography } from '@material-ui/core';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';

import { AppSelect } from './InputComponents';

import useStyles from "./LetsGetKnow.style";

import { arrayOfNumbers, arrayOfPeriodAges } from "../../../services/util.service";

const GettingDeeper = props => {
    const classes = useStyles();

    const currentAge = new Date(Date.now()).getFullYear() - new Date(props.dateOfBirth).getFullYear();
    const currentYear = new Date().getFullYear();
    var isPeriodEligibleAge = currentAge < 8 ? false : true;

    return (
        <Box className={classes.root}>
            {/* Header */}
            <Box><QuestionAnswerIcon className={classes.textIcon} /></Box>
            <Typography variant="h4" className={classes.title}>Let’s track your health milestones</Typography>
            <Typography className={classes.subTitle}>
            </Typography>
            {props.error && !props.validator.allValid() &&
                <Typography color="error">
                    Please review your answers
                </Typography>
            }
            {/* First menstruation */}
            <Box className={classes.inputSection}>
                <Typography variant="h5">
                
                    What age did you start your period?
                    {
                    <span className={props.error && !props.validator.fieldValid('firstPeriodAge') ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                }
                    </Typography>
                <AppSelect
                    id="firstPeriodAge"
                    label="Age"
                    value={props.firstPeriodAge}
                    items={['', "I haven't started my first period", ...arrayOfPeriodAges(currentAge, isPeriodEligibleAge)]}
                    fullWidth
                    margin="normal"
                    onChange={props.onFirstPeriodAgeChange}
                    error={props.error && !props.validator.fieldValid('firstPeriodAge')}
                    helperText={props.validator.message('firstPeriodAge', props.firstPeriodAge, 'required')}
                />
            </Box>
            {/* Sexually active */}
            <Box className={classes.inputSection}>
                <Typography variant="h5">
                
                    When did you become sexually active?
                    {
                    <span className={props.error && !props.validator.fieldValid('sexuallyActiveAge') ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                }
                    </Typography>
                <AppSelect
                    id="sexuallyActive"
                    label="Age"
                    value={props.sexuallyActiveAge}
                    items={['', 'I am not yet sexually active', ...arrayOfNumbers(10, currentAge - 9)]}
                    fullWidth
                    margin="normal"
                    onChange={props.onSexuallyActiveAgeChange}
                    error={props.error && !props.validator.fieldValid('sexuallyActiveAge')}
                    helperText={props.validator.message('sexuallyActiveAge', props.sexuallyActiveAge, 'required')}
                />
            </Box>
            {/* Menopause */}
            <Box className={classes.inputSection}>
                <Typography variant="h5">
                
                    Have you reached menopause?
                    {
                    <span className={props.error && !props.validator.fieldValid('menopause') ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                }
                    </Typography>
                <FormControl
                    component="fieldset"
                    error={props.error && !props.validator.fieldValid('menopause')}
                >
                    <RadioGroup row
                        aria-label="Menopause"
                        value={props.menopause}
                        onChange={props.onMenopauseChange}
                    >
                        {['Yes', 'No', 'Unsure'].map((answer, i) =>
                            <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                        )}
                    </RadioGroup>
                    <FormHelperText>
                        {props.validator.message('menopause', props.menopause, 'required')}
                    </FormHelperText>
                </FormControl>
            </Box>

            {/* Have been pregnant? */}
            <Box className={classes.inputSection}>
                <Typography variant="h5">
                
                    Have you ever been pregnant?
                    {
                    <span className={props.error && !props.validator.fieldValid('haveBeenPregnant') ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                }
                    </Typography>
                <FormControl
                    component="fieldset"
                    error={props.error && !props.validator.fieldValid('haveBeenPregnant')}
                >
                    <RadioGroup row
                        aria-label="HaveBeenPregnant"
                        value={props.haveBeenPregnant}
                        onChange={props.onHaveBeenPregnantChange}
                    >
                        {['Yes', 'No', 'Currently Pregnant'].map((answer, i) =>
                            <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                        )}
                    </RadioGroup>
                    <FormHelperText>
                        {props.validator.message('haveBeenPregnant', props.haveBeenPregnant, 'required')}
                    </FormHelperText>
                </FormControl>
            </Box>
            {/* Current Pregnancy Due Date */}
            <Box className={classes.inputSection} display={props.haveBeenPregnant === 'Currently Pregnant' ? 'block' : 'none'}>
                <Typography variant="h5">
                
                    What is your expected due date?
                    {
                    <span className={props.error && !props.validator.fieldValid('currentPregnancyDueDate') ? `${classes.asteriskError}` : `${classes.asteriskNormal}`} >*</span>
                }
                    </Typography>
                <AppSelect
                    id="currentPregnancyDueDate"
                    label="Year"
                    value={props.currentPregnancyDueDate}
                    items={['', ...arrayOfNumbers(currentYear, 2)]}
                    fullWidth
                    margin="normal"
                    onChange={props.onCurrentPregnancyDueDateChange}
                    error={props.error && !props.validator.fieldValid('currentPregnancyDueDate')}
                    helperText={props.validator.message('currentPregnancyDueDate', props.currentPregnancyDueDate, `current_pregnancy_due_date_year:${props.haveBeenPregnant}`)}
                />
            </Box>
        </Box>
    );
};

export default GettingDeeper;
